import api from './api';

export default async function deleteAssetImage(image_id) {
    const { data } = await api.delete(`assets_images/${image_id}`);
    return data;
}